import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const useResendWelcomeEmailMutation = () => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ userId }: { userId: string }) => {
			const params = new URLSearchParams({ userId });
			return userSession.webServiceHelper.callAsync(
				`admin/userOperations/resendWelcomeEmail?${params.toString()}`,
				'POST'
			);
		},
	});
};
